var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  fillRule: "evenodd",
  d: "M7 .19a6.81 6.81 0 1 1 0 13.62A6.81 6.81 0 0 1 7 .19m-.016 1.236a5.615 5.615 0 1 0 0 11.23 5.615 5.615 0 0 0 0-11.23m-.692 1.99c0-.888 1.374-.888 1.374 0v2.65q.58-.575 1.161-1.148c.631-.624 1.604.348.97.97Q8.633 7.044 7.465 8.197l-.007.005-.022.019a.63.63 0 0 1-.698.116.62.62 0 0 1-.44-.562 1 1 0 0 1-.005-.101z",
  clipRule: "evenodd"
})));
export { SvgClock as ReactComponent };